// A utility function to remove basenames, to handle basename/no basename conflicts until we properly sort out all routes
export const removeURLBasename = (url) => {
  if (typeof url !== "string") {
    throw new Error("Input must be a string");
  }

  const tokens = url.split("/");
  let index = tokens.indexOf("company");
  if (index > -1) {
    tokens.splice(index, 2);
  }

  index = tokens.indexOf("router");
  if (index > -1) {
    tokens.splice(index - 1, 2);
  }

  return tokens.join("/");
};
